module.exports = __webpack_public_path__ + "static/media/p_frv_Mainmal_Shirt.0556f0c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Pcg/p_frv_Mainmal_Shirt.png
// module id = 550
// module chunks = 0